import http from "../../http";

const info = {
    saveType(r) {
        return  http.confirm.payload("/gateway/api/recommend/BehaviorDataController/saveType",r )
    },
    selectTypeList(r) {
        return  http.get("/gateway/api/recommend/BehaviorDataController/selectTypeList",r )
    },
    deleteType(r) {
        return  http.confirm.post("/gateway/api/recommend/BehaviorDataController/deleteType",r )
    },
    saveLabel(r) {
        return  http.confirm.payload("/gateway/api/recommend/BehaviorDataController/saveLabel",r )
    },
    selectLabelList(r) {
        return  http.get("/gateway/api/recommend/BehaviorDataController/selectLabelList",r )
    },
    deleteLabel(r) {
        return  http.confirm.post("/gateway/api/recommend/BehaviorDataController/deleteLabel",r )
    },
    searchManagerInformation(r) {
        return  http.spin.get("/gateway/api/recommend/RecommendController/searchManagerInformation",r )
    },
    searchInformationAPI(r) {
        return  http.spin.get("/gateway/api/recommend/RecommendController/searchInformationAPI",r )
    },
    saveBehaviorData(r) {
        return  http.confirm.payload("/gateway/api/recommend/BehaviorDataController/saveBehaviorData",r )
    },
    updateInfoList(r) {
        return  http.confirm.payload("/gateway/api/recommend/RecommendController/updateInfoList",r )
    }
    

}
export default info
